<template>
  <a-card title="设备变量">
    <template  #extra>
        <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
          <template  #btn>
              <a-form-item>
              <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增 </a-button>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" v-if="auth.edit>0" @click="writein"><EditOutlined /> 写入值 </a-button>
            </a-form-item>
          </template>
        </lanseed-form-only>
    </template>
    <a-table rowKey="ID" :row-selection="rowselection" :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
       <template v-if="column.key === 'Method'">
        {{ AutoData.FindName(datamodel,'Method',record.Method) }}
       </template>
      <template v-if="column.key === 'IsTrigger'">
        <a-switch :checked="record.IsTrigger" />
      </template>
      <template v-if="column.key === 'IsUpload'">
        <a-switch :checked="record.IsUpload" />
      </template>
      <template v-if="column.key === 'ProtectType'">
        {{ AutoData.FindName(datamodel,'ProtectType',record.ProtectType) }}
      </template>
      <template v-if="column.key === 'AlarmExpressions'">
        <template v-if="record.AlarmExpressions">
              <div v-for="(t,z) in JSON.parse(record.AlarmExpressions)">
                  <span class="text-yellow" v-if="z==0">警示</span>
                  <span class="text-orange" v-else-if="z==1">危险</span>
                  <span class="text-red" v-else-if="z==2">严重</span>
                  <span class="margin-left-sm">{{ t[0] }} - {{t[1] }}</span>
              </div>
        </template>
        <a-switch v-else :checked="false"></a-switch>
      </template>

      <template v-if="column.key === 'operation'">
        <a-button-group>
            <a-button v-if="auth.edit"  size="small" type="primary" @click="edit(record)">
                <EditOutlined /> 修改
            </a-button>
            <a-button v-if="auth.del"  size="small" type="primary" @click="del(record)">
                <DeleteOutlined /> 删除
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>
    <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit">
      <a-divider>
        <span class="flex align-center">
          <span class="margin-right">告警设置</span>
          <a-switch class="margin-right" :checked="useAlarm" @change="onUseAlarm" />
          <a-slider v-if="useAlarm"  style="width:100px;" v-model:value="alarmStep" :min="1" :max="10" :step="1"></a-slider>
        </span>
      </a-divider>

        <div v-if="useAlarm==false" class="flex align-center text-gray padding justify-center">
              未启用告警设置
        </div>
        <div  v-else>
          <div class="flex1 text-yellow">提警
            <span class="text-bolder text-lg">
            {{ alarmData[0][0] }}-{{ alarmData[0][1] }}</span>
          </div>
            <div class="flex align-center margin-bottom">
              <MinusCircleOutlined @click="()=>{alarmNumber[0]-=alarmStep}"  class="margin-right text-lg text-primary" />
              <a-slider class="flex1" :disabled="useAlarm==false"    range  v-model:value="alarmData[0]" :step="alarmStep" :min="alarmNumber[0]" :max="alarmData[1][0]"></a-slider>

            </div>
            <div class="flex1 text-orange">
              警告 <span class="text-bolder text-lg">{{ alarmData[1][0] }}-{{ alarmData[1][1] }}</span>
            </div>
            <div class="flex align-center margin-bottom">
            <a-slider class="flex1"  :disabled="useAlarm==false"   v-model:value="alarmData[1]" range :step="alarmStep"  :min="alarmData[0][1]+1" :max="alarmData[2][0]-1"></a-slider>
            </div>
            <div class="flex1 text-red">
              危险
              <span class="text-bolder text-lg">{{ alarmData[2][0] }}-{{ alarmData[2][1] }}</span></div>
            <div class="flex align-center">
              <a-slider class="flex1"   :disabled="useAlarm==false"   v-model:value="alarmData[2]" range :step="alarmStep"  :min="alarmData[1][1]+1" :max="alarmNumber[1]"></a-slider>
              <PlusCircleOutlined  @click="()=>{alarmNumber[1]+=alarmStep}" class="margin-left  text-lg text-primary" />
            </div>

        </div>
    </lanseed-form>
    <a-modal ref="modalRef" title="写入数据" v-model:open="OpenWriter"  @ok="dowrite">
       <a-space >
        <a-input type="number"  placeholder="输入要写入的数据" v-model:value="WriteValue"></a-input>
       </a-space>
    </a-modal>
  </a-card>
</template>
<script setup lang="ts">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent, onUnmounted} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined,MinusCircleOutlined,PlusCircleOutlined} from '@ant-design/icons-vue'

import { AutoData } from '@/utils/util'
import { message ,notification } from 'ant-design-vue'
  const props=defineProps({
    DeviceId:{type:Number,required:true},
    auth:{type:Object,default:()=>{return {see:1,creating:1,edit:1,del:1,agent:0}}}
  })
  const alarmData=ref<Array<Array<number,number>>>([])
  const useAlarm=ref<boolean>(false)
  const alarmNumber=ref<Array<number,number>>([0,100])
  const alarmStep=ref<number>(1)
  const datamodel=ref<any>()//原始数据类型
  onMounted(()=>{
    api.devicevar.model(props.DeviceId).then(res=>{
      if(res.state==1){
        datamodel.value=AutoData.InitModel(res.data)
        columns.value=AutoData.GetTableModel(datamodel.value,['Name','Description','Method', 'IsTrigger','IsUpload','ProtectType','AlarmExpressions'])

        /*
        这里有些不同，ExtendData以字符存储独立类中的数据，这些子类字段会全部加入datamodel，
        ExtendData中存储了需要的字段,字段名为"ExtendData___子名称"，在保存时，需要同样ExtendData___中的字段值组装成object ，再以JSON.stringify()转出并保存给ExtendData,反之在编辑数据时，需要反则转化
        */

        var editField=['Name','Description','Method','DeviceAddress', 'IsTrigger', 'Expressions','IsUpload','Unit']
        for(var k in res.data){
          if(k.startsWith('ExtendData___')){
            editField.push(k)
          }
        }
        var role=AutoData.GetFormModel(datamodel.value,editField)
        formRole.value=role
        getList()
      }
    })
  })
const onUseAlarm=(e:boolean)=>{
  if(e==true){
    alarmData.value= [[0,0],[0,0],[0,0]]
  }else{
    alarmData.value=[]
  }
  useAlarm.value=e
}
const rowselection:any=ref({
  fixed:true,
  selectedRowKeys:[],
  onChange:(e:any)=>{
    rowselection.value.selectedRowKeys=e
  }
})
const searchVal:Record=ref({
  keyword:'',
})
const searchRule:Record=ref({
  keyword:{name:'关键字'}
})
const columns=ref<Array<object>>()
const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.devicevar.list({pageIndex:page.value.current,pageSize:page.value.pageSize,DeviceId:props.DeviceId,...searchVal}).then(res => {
        loading.value=false
        dataSource.value=res.data.data
        page.value.total=res.data.records
        page.value.current=res.data.pageIndex
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }

const formModel:Record=ref({})
const formRole=ref({})
const formshow=ref<Boolean>(false)
const add=()=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,{DeviceId:props.DeviceId,ID:0,Sort:0,AlarmStatus:0,ProtectType:0,Status:0})
  formshow.value=true
}
const edit=(d:object)=>{
  if(d.AlarmExpressions){
    var ds=JSON.parse(d.AlarmExpressions)
    alarmNumber.value=[ds[0][0]-50,ds[2][1]+50]
    alarmData.value=ds
    useAlarm.value=true
  }else{
    useAlarm.value=false
  }
  if(d.ExtendData){
    var ed= JSON.parse(d.ExtendData)
    var ext={}
    for(var k in ed){
      ext['ExtendData___'+k]=ed[k]
    }
    Object.assign(d,ext)
  }
  var v=AutoData.GetDefaltModel(datamodel.value,d)
  formModel.value=v
  formshow.value=true
}
const del=(d:object,i:Number)=>{
  api.devicevar.del(d.ID).then(res=>{
    if(res.state==1){
         dataSource.value.splice(i,1)
    }
   })
}

const submit=(e:any)=>{
  if(useAlarm.value){
    e.AlarmExpressions=JSON.stringify(alarmData.value)
  }else{
    e.AlarmExpressions=null
  }
  var ext={}
  for(var k in e){
    if(k.startsWith('ExtendData___')){
      ext[k.replace('ExtendData___','')]=e[k]
    }
  }
  e.ExtendData=JSON.stringify(ext)
  api.devicevar.add(e).then(res=>{
    if(res.state==1){
      getList()
      formshow.value=false
      alarmData.value=null
      useAlarm.value=false
    }
  })
}
const OpenWriter=ref<Boolean>(false)
const WriteValue=ref<Number>(0)
const writein=()=>{
  if(rowselection.value.selectedRowKeys.length==0){
    message.info('请至少选择一行')
    return false
  }
  OpenWriter.value=true
}
const dowrite=()=>{
  if(rowselection.value.selectedRowKeys.length==0){
    message.info('请至少选择一行')
    return false
  }
  if(WriteValue.value==""||WriteValue.value==null){
     message.info('请填入值')
     return false
  }
  let ids=rowselection.value.selectedRowKeys.join(',')
  api.devicevar.set(props.DeviceId,ids,WriteValue.value).then(res=>{
    if(res.state==1){
      OpenWriter.value=false
      if(res.data==true){
        notification.success({message:'指令下发成功'})
      }
    }
  })
}
</script>
